export const GET_WIDGETS = "GET_WIDGETS";
export const SET_WIDGETS = "SET_WIDGETS";
export const RESET_WIDGETS = "RESET_WIDGETS";

export const API_ERROR = "WIDGETS_API_ERROR";

export const GET_WIDGET = "GET_WIDGET";
export const SET_WIDGET = "SET_WIDGET";

export const UNMOUNT_WIDGET = "UNMOUNT_WIDGET";